import { features } from '@/content/site';
import { FeatureIcon } from '@/components/Icons';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import './FeaturesGrid.css';

export function FeaturesGrid() {
  return (
    <Section
      id="producto"
      label="Plataforma completa"
      title="Todo lo que tu operación conversacional necesita"
      lead="Desde el primer agente hasta reservas con seña y permisos por rol: una sola plataforma."
    >
      <div className="features-grid">
        {features.map((f, i) => (
          <ScrollReveal key={f.title} delay={(i % 4) * 60}>
            <article className="glass-card feature-card">
              <div className="feature-card__icon">
                <FeatureIcon name={f.icon} />
              </div>
              <h3>{f.title}</h3>
              <p>{f.description}</p>
            </article>
          </ScrollReveal>
        ))}
      </div>
    </Section>
  );
}
